import AvatarFallback from "./AvatarFallback";
import React from "react";
import { Box, Typography } from "@mui/material";
import { MoreHorizontalIcon } from "../AdaptiveIcon";

const Telegram = ({
  selectedAccounts,
  formattedTags,
  accResp,
  selectedImages,
  selectedIndex,
  avatars,
  postText,
  inlineKeyboard,
}) => {
  const numImages = selectedImages.length;

  let gridColumns;
  let gridRows;

  if (numImages === 1) {
    gridColumns = "auto";
    gridRows = "auto";
  } else if (numImages === 2) {
    gridColumns = "1fr 1fr";
    gridRows = "50%";
  } else if (numImages === 3) {
    gridColumns = "auto minmax(33.33%, 1fr)";
    gridRows = "50% 50%";
  } else if (numImages >= 4) {
    gridColumns = "auto minmax(33.33%, 1fr)";
    gridRows = "repeat(3, 33.33%)";
  }

  return (
    <Box className="tab-pane h-full">
      <Box className="user-container p-10 relative mx-5">
        <Box
          className="instHeader mt-4"
          sx={{
            height: "21px",
            position: "relative",
            marginBottom: selectedAccounts.length === 0 ? "0px" : "30px",
          }}>
          {selectedAccounts.length === 0 ? (
            <Box
              className="avatar"
              sx={{
                width: "50px",
                height: "50px",
                borderRadius: "51%",
                backgroundColor: "var(--background-preview)",
                position: "absolute",
              }}
            />
          ) : (
            <>
              {selectedAccounts.map((id, i) => {
                const index = accResp.findIndex((acc) => acc.id === id);
                const avatar = avatars[index];
                const userName = accResp[index].username;

                return (
                  <Box
                    key={id}
                    className="author-img"
                    sx={{
                      backgroundColor: "var(--background-preview)",
                      position: "absolute",
                      display: i === selectedIndex ? "flex" : "none",
                      alignItems: "center",
                    }}>
                    <AvatarFallback
                      src={avatar}
                      name={userName}
                      background="#0088cc"
                      className="w-full h-full object-cover mr-2"
                      style={{ borderRadius: "50%" }}
                    />
                    <Box className="flex items-center">
                      <Typography
                        className="whitespace-nowrap"
                        sx={{
                          marginLeft: "10px",
                          color: "var(--text-color)",
                        }}>
                        {userName}
                      </Typography>
                      <Typography
                        className="whitespace-nowrap"
                        sx={{
                          color: "#a9a9a9",
                          fontSize: "12px",
                        }}>
                        ・1 min. ago
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </>
          )}
          <Box className="absolute right-0">
            <MoreHorizontalIcon fontSize="large" />
          </Box>
        </Box>
        <Box
          className="user-info"
          style={{ position: "relative", paddingLeft: "60px", top: "-25px" }}>
          {selectedAccounts.length === undefined ||
          selectedAccounts.length === 0 ? (
            <>
              <Box
                style={{
                  width: "30%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}
              />
              <Box
                style={{
                  width: "10%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}
              />
            </>
          ) : null}
        </Box>
        {selectedImages.length > 0 && (
          <Box className="flex justify-center mb-4">
            <Box style={{ width: "523px", height: "523px" }}>
              <Box
                className={`media-preview-template ${
                  numImages > 4 ? "overflow" : ""
                }`}
                style={{
                  gridTemplateColumns: gridColumns,
                  gridTemplateRows: gridRows,
                }}>
                {selectedImages.slice(0, 1).map((image, index) => (
                  <img
                    key={index}
                    src={image.props.src}
                    alt="Selected"
                    style={{
                      gridArea: "1 / 2 / span 2 / span 2",
                      width: "523px",
                      height: "523px",
                    }}
                  />
                ))}
                {selectedImages.slice(1, 5).map((image, index) => (
                  <img key={index + 1} src={image.props.src} alt="Selected" />
                ))}
                {numImages > 5 && (
                  <Box className="last-image-overlay">
                    <Typography className="numImages" component="span">
                      +{numImages - 5}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        )}

        {postText === undefined || postText === "" ? (
          <Box className="flex flex-col mb-2">
            <Box sx={{ width: "85%", display: "block", alignSelf: "center" }}>
              <Box
                style={{
                  width: "95%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "65%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "45%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
            </Box>
          </Box>
        ) : (
          <>
            <Box sx={{
              background: "#effdde",
              borderRadius: "12px 12px 2px 12px",
              padding: "10px 14px",
              maxWidth: "85%",
              marginLeft: "auto",
              boxShadow: "0 1px 2px rgba(0,0,0,0.15)",
            }}>
              <Typography
                component="div"
                style={{
                  whiteSpace: "pre-wrap",
                  marginBottom: "4px",
                  color: "#000",
                  fontSize: "14px",
                  lineHeight: "1.5",
                }}>
                {postText}
              </Typography>
              <Typography
                component="div"
                style={{
                  whiteSpace: "pre-wrap",
                  color: "#1d9bf0",
                  fontSize: "14px",
                }}>
                {formattedTags}
              </Typography>
              <Typography sx={{ fontSize: "11px", color: "#8e9ea8", textAlign: "right", marginTop: "4px" }}>12:34 ✓✓</Typography>
            </Box>
            {/* Inline keyboard */}
            {Array.isArray(inlineKeyboard) && inlineKeyboard.length > 0 && (
              <Box sx={{ maxWidth: "85%", marginLeft: "auto", mt: "3px" }}>
                {inlineKeyboard.map((row, rowIdx) => (
                  <Box key={rowIdx} sx={{ display: "flex", gap: "3px", mb: "3px" }}>
                    {row.filter(btn => btn.text).map((btn, btnIdx) => (
                      <Box
                        key={btnIdx}
                        sx={{
                          flex: 1,
                          textAlign: "center",
                          backgroundColor: "rgba(42,171,238,0.12)",
                          border: "1px solid rgba(42,171,238,0.3)",
                          borderRadius: "6px",
                          padding: "5px 8px",
                          fontSize: "11px",
                          color: "#2AABEE",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}>
                        {btn.url ? "🔗 " : ""}{btn.text}
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default Telegram;
